"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("@mui/material"),e=require("@mui/material/styles"),n=e.styled(t.Menu)`
  .MuiMenu-list {
    padding: 0;
    outline: none;
  }
`,i=e.styled(t.MenuItem)`
  &&.MuiMenuItem-root {
    padding: 6px 8px;
    display: flex;
    outline: none;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 700;
    line-height: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    align-items: center;
    height: 24px;
  }
`,s=e.styled(t.Typography)`
  display: flex;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;exports.OptionText=s;exports.StatusMenu=n;exports.StatusOptions=i;
